import {useState} from "react";
import {YStack} from "../YStack";

export interface ManagedImageProps {
  src: string;
  alt: string;
  priority?: boolean;
  className?: string;
  imageClassName?: string;
  errorMessage?: string;
}

export const ManagedImage = ({
  src,
  alt,
  priority = false,
  className,
  imageClassName = "h-full w-full object-cover",
  errorMessage = "Не удалось загрузить изображение",
}: ManagedImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className={`relative h-full w-full overflow-hidden bg-black/5 ${className ?? ""}`.trim()}>
      {!isLoaded && !hasError && <div aria-hidden="true" className="absolute inset-0 bg-black/5" />}
      {hasError ? (
        <YStack className="absolute inset-0 items-center justify-center px-4 text-center text-sm text-controls-gray">
          {errorMessage}
        </YStack>
      ) : (
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={priority ? "high" : "auto"}
          draggable={false}
          className={`${imageClassName} ${isLoaded ? "visible" : "invisible"}`.trim()}
          onLoad={() => setIsLoaded(true)}
          onError={() => {
            setHasError(true);
            setIsLoaded(false);
          }}
        />
      )}
    </div>
  );
};
